import * as load from "./loading.json";

export const defaultOptions1 = {
  loop: true,
  autoplay: true,
  animationData: load.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};
